export default "__VITE_ASSET__DgvasHpX__"